import Moment from 'moment';

export const dateFns = {
  addDays: (date: Date, days: number): Date => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  },
  startOfDay: (date: Date): Date => {
    const d = new Date(date);
    d.setHours(2, 0, 0, 0);
    return d;
  },
  daysBetweenDates: (startDate: Date | string, endDate: Date | string): number => {
    // Using prior date to get inclusive day difference
    const priorDate = new Date(startDate).setDate(new Date(startDate).getDate() - 1);

    const startTime = new Date(priorDate).getTime();
    const endTime = new Date(endDate).getTime();

    return Math.floor((endTime - startTime) / (24 * 3600 * 1000));
  },
  isPreviousDate: (actualDate: Date | string): boolean =>
    new Date(actualDate).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0),

  monthsBetweenDates: (dateOne: Date, dateTwo: Date): number => {
    const startDate = new Date(dateOne);
    const endDate = new Date(dateTwo);

    const monthsDiff = endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear());

    return monthsDiff > 0 ? monthsDiff : 0;
  },
  valueOf(date?: Date): number {
    return date?.valueOf() ?? 0;
  },
  getTimeStringFromDateTime(date: Date | string): string {
    if (!date) {
      return '00:00';
    }

    const newDate = new Date(date);

    const hours = newDate.getHours() < 10 ? '0' + newDate.getHours() : newDate.getHours();
    const minutes = newDate.getMinutes() < 10 ? '0' + newDate.getMinutes() : newDate.getMinutes();

    return `${hours}:${minutes}`;
  },
  getDateTimeWithSetTime(date: string, time: string): Date {
    const updatedDate = new Date(date);

    if (time) {
      const hours = +time.substring(0, 2);
      const minutes = +time.substring(3, 5);

      updatedDate.setHours(hours);
      updatedDate.setMinutes(minutes);
    }

    return updatedDate;
  },

  isValidMomentDate(value: any, validDateFormats: string[]): boolean {
    const valueType = typeof value?._i;

    // Only validate if the value was written manually
    if (valueType === 'string') {
      const val = value?._i;
      const minLengthFormat = Math.min(...validDateFormats.map(item => item.length));
      if (val.length < minLengthFormat) {
        return false;
      }

      let isValidDate = false;
      validDateFormats.forEach(format => {
        const momentDate = Moment(val, format, true);

        if (momentDate.isValid()) {
          isValidDate = true;
          return;
        }
      });

      return isValidDate;
    }
    // If the value is an object, it is most likely chosen in the datepicker
    else if (valueType === 'object') {
      return true;
    }

    return false;
  },

  DateStringToDate(date: string): Date {
    if (!date) {
      return null;
    }

    const d = date.split('-');
    if (d.length === 3) {
      const year = +d[0];
      const month = +d[1];
      const day = +d[2];
      if (year > 0 && month <= 12 && month > 0 && day <= 31 && day > 0) {
        return new Date(date);
      }
    }
    return null;
  },
  isBefore(date1: Date, date2: Date): boolean {
    const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

    return d1 < d2;
  },
  isAfter(date1: Date, date2: Date): boolean {
    const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

    return d1 > d2;
  },
};
